
export default {
	name: "AnswersTable",
	props: {
		tableHeaders: {
			type: Array,
			required: false,
			default: () => ["Date", "Puzzle #", "Answer"],
		},
		rows: {
			type: Array,
			required: false,
			default: () => [],
		},
	},
};
